import React from 'react';
import styled from 'styled-components';

const EyeOpenIcon = () => {
return(
    <Container>
        <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.79279 7.81618C3.51192 7.99291 3.15219 7.8891 2.98929 7.58413L0.745385 3.38268C0.58257 3.0778 0.678205 2.68731 0.959154 2.51048C1.24002 2.33375 1.59976 2.43756 1.76265 2.74253L4.00656 6.94398C4.16937 7.24886 4.07374 7.63935 3.79279 7.81618Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.19661 5.55273C7.87678 5.61383 7.57193 5.38203 7.51556 5.03494L6.81985 0.748403C6.76357 0.401226 6.9771 0.0703 7.29686 0.00911845C7.61661 -0.0519782 7.92154 0.179815 7.97791 0.526908L8.67362 4.81344C8.7299 5.16054 8.51637 5.49155 8.19661 5.55273Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1375 5.56253C12.8177 5.50151 12.604 5.17067 12.6602 4.8235L13.3559 0.526322C13.4121 0.17923 13.7169 -0.0527335 14.0367 0.00827785C14.3565 0.0692892 14.5702 0.400129 14.514 0.747307L13.8183 5.04448C13.7621 5.39158 13.4573 5.62354 13.1375 5.56253Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M17.5413 7.81684C17.26 7.6407 17.1636 7.25047 17.3258 6.94515L19.5697 2.72244C19.7319 2.41712 20.0915 2.31238 20.3727 2.48852C20.654 2.66457 20.7505 3.05489 20.5882 3.36021L18.3443 7.58292C18.1821 7.88824 17.8226 7.99298 17.5413 7.81684Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M20.4392 10.1434C20.1866 10.3649 19.8164 10.3221 19.6124 10.0479C18.0312 7.92284 15.165 5.27527 10.663 5.27527C6.16095 5.27527 3.29486 7.92284 1.71358 10.0479C1.50953 10.3221 1.13937 10.3649 0.886801 10.1434C0.634228 9.92192 0.594799 9.52011 0.798847 9.24594C2.50994 6.94623 5.67987 3.99888 10.663 3.99888C15.6461 3.99888 18.816 6.94623 20.5271 9.24594C20.7312 9.52011 20.6918 9.92192 20.4392 10.1434Z"
                  fill="#333333"/>
            <path
                d="M13.4965 10.9138C13.4965 12.3063 12.265 13.4995 10.6633 13.4995C9.06152 13.4995 7.83008 12.3063 7.83008 10.9138C7.83008 9.52141 9.06152 8.32812 10.6633 8.32812C12.265 8.32812 13.4965 9.52141 13.4965 10.9138Z"
                stroke="#333333"/>
        </svg>
    </Container>
)

}
export default EyeOpenIcon;

const Container = styled.div`

`;